import React, { Component } from "react";
import Carousel from "react-bootstrap/Carousel";
import tile4 from "../assets/4.png";

export default class CarouselBox extends Component {
  render() {
    return (
      <Carousel>
        <Carousel.Item>
          <img
            className="d-block w-100"
            style={{ height: 800 }}
            src="https://egrace.by/wp-content/uploads/2020/06/romb.jpg"
            alt="Paving slabs"
          />
          <Carousel.Caption>
            <h3>Тротуарная плитка</h3>
            <p>:)</p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100"
            style={{ height: 800 }}
            src="https://unimart24.ru/upload/uf/41d/41de5a1179f21e0ca032246ee1525e56.jpg"
            alt="Paving slabs"
          />
          <Carousel.Caption>
            <h3>Тротуарная плитка</h3>
            <p>:)</p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100"
            style={{ height: 800 }}
            src={tile4}
            alt="Paving slabs"
          />
          <Carousel.Caption>
            <h3>Тротуарная плитка</h3>
            <p>:)</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    );
  }
}
